import { Module } from '../../issue/types/modulesv2';
import { NormalizedSignal } from '../services/signals';
import { SignalCollectors, SignalEntity } from '../types';
import { signalCredentiasExposureDrawer } from './signal-credential.drawer';
import { credentialLeft, credentialRight } from './signal-credential.issuemodules';
import { signalSourceDrawer } from './signal-source.drawer';
import { sourceLeft, sourceRight } from './signal-source.issuemodules';
import { signalDrawer } from './signal.drawer';

type SignalModule<T = SignalEntity> = (
  collector: SignalCollectors,
  title?: string
) => Array<Module<T>>;

type SignalConfig = {
  issue: readonly [SignalModule, SignalModule] | null;
  drawer: SignalModule<NormalizedSignal>;
  title?: string;
};

const signalSourceConfig = {
  issue: [sourceLeft, sourceRight] as const,
  drawer: signalSourceDrawer,
};

const signalConfigMap: Record<SignalCollectors, SignalConfig> = {
  'forum-posts': signalSourceConfig,
  telegram: signalSourceConfig,
  'view-ransomware': signalSourceConfig,
  ransompage: signalSourceConfig,
  ransomwatch: signalSourceConfig,
  'rss-collector': { ...signalSourceConfig, title: 'RSS Feed' },
  botnetlogparser: {
    issue: [credentialLeft, credentialRight],
    drawer: signalCredentiasExposureDrawer,
  },
  botnetlogs: {
    issue: [credentialLeft, credentialRight],
    drawer: signalCredentiasExposureDrawer,
  },
  intelx: {
    issue: [credentialLeft, credentialRight],
    drawer: signalCredentiasExposureDrawer,
  },
  cybint: {
    issue: [credentialLeft, credentialRight],
    drawer: signalCredentiasExposureDrawer,
  },
  'cluster-articles': signalSourceConfig,
};

export const getSignalConfig = (collector: SignalCollectors) => {
  if (!collector) {
    return {
      issue: [() => [], () => []] as const,
      drawer: () => [],
    };
  }

  const config = signalConfigMap[collector];

  if (!config) {
    return {
      issue: null,
      drawer: signalDrawer,
    };
  }

  return config;
};
